import React from 'react';
import { FiPlay } from 'react-icons/fi';

const Hero = () => {
  return (
    <section
      id="top"
      className="section hero hero-photo"
      style={{ backgroundImage: `url(${process.env.PUBLIC_URL + '/assets/IMG_3143.JPG'})` }}
    >
      <div className="container hero-inner">
        <div className="hero-copy">
          <p className="eyebrow">NEW EP OUT NOW</p>
          <h1 className="hero-title">
            I <span className="block-accent">AM</span>
          </h1>
          <p className="hero-desc">
            A bold sound with sharp edges. No gradients—just solid vibes.
          </p>
          <div className="hero-actions">
            <a href="https://tr.ee/tvwDfBXSIO" target="_blank" rel="noreferrer" className="btn btn-primary">
              <FiPlay aria-hidden="true" /> Listen on Spotify
            </a>
            <a href="/donate.html" className="btn btn-ghost">Donate Now</a>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Hero;
